import React from 'react';
import { Box, CircularProgress as MuiCircularProgress } from '@mui/material';
var CircularProgress = function (_a) {
    var value = _a.value, className = _a.className;
    return (React.createElement(Box, { position: "relative", display: "inline-flex", className: "circularProgress " + className },
        React.createElement(MuiCircularProgress, { variant: "determinate", value: value }),
        React.createElement("div", { className: "circularProgress__label" }, value + "%")));
};
export default CircularProgress;
//# sourceMappingURL=CircularProgress.js.map